import * as React from 'react'
import Accordion, {AccordionProps} from '@mui/material/Accordion'
import AccordionSummary, {
  AccordionSummaryProps,
} from '@mui/material/AccordionSummary'
import AccordionDetails, {
  AccordionDetailsProps,
} from '@mui/material/AccordionDetails'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import styled from 'styled-components'
import accordionStyles from './accordion.styles'

// AccordionAtom
//= =====================================
const apAtomNameAccordion = {ap_atom_name: 'accordionAtom'}
export const AccordionAtom = styled((props: AccordionProps) => (
  <Accordion {...apAtomNameAccordion} {...props} />
))`
  ${accordionStyles}
`

// AccordionSummaryAtom
//= =====================================
interface ApAccordionSummaryProps extends AccordionSummaryProps {
  ap_type?: 'deliverySummary'
}
const apAtomNameAccordionSummary = {ap_atom_name: 'accordionSummaryAtom'}
export const AccordionSummaryAtom = styled((props: ApAccordionSummaryProps) => (
  <AccordionSummary
    {...apAtomNameAccordionSummary}
    expandIcon={<ExpandMoreIcon />}
    aria-controls={props.id}
    {...props}
  />
))`
  ${accordionStyles}
`

// AccordionDetailsAtom
//= =====================================
interface ApAccordionDetailsProps extends AccordionDetailsProps {
  ap_type?: 'deliveryDetails'
}
const apAtomNameAccordionDetails = {ap_atom_name: 'accordionDetailsAtom'}
export const AccordionDetailsAtom = styled((props: ApAccordionDetailsProps) => (
  <AccordionDetails {...apAtomNameAccordionDetails} {...props} />
))`
  ${accordionStyles}
`

export default AccordionAtom
